<template>
  <v-card outlined class="rounded-card card-shadow">
    <v-card-text class="text--primary px-6 pt-8">
      <px-acompanhamentos allow-files
                          is-marketplace
                          disabled
                          :item-type="messageType"
                          :item-id="compra.id"
                          :user="user"
                          @on-message="onMessage"/>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    compra: Object,
  },
  data() {
    return {
      messageType: this.$px.types.COMPRAS_MARKERTPLACE,
    };
  },
  computed: {
    ...mapGetters('user', ['user']),
  },
  methods: {
    onMessage() {
      // não notificar
    },
  },
};
</script>
